export enum IgtMessages {
  GAME_LOAD_COMPLETED = 'gameLoadComplete',
  GAME_LOAD_STARTED = 'gameLoadStarted',
  GAME_LOAD_PROGRESS = 'gameLoadProgress',
  GAME_ANIMATION_START = 'gameAnimationStart',
  GAME_ANIMATION_COMPLETED = 'gameAnimationComplete',
  SETTINGS_UPDATE = 'settingsUpdate',
  NOTIFY_ACTION = 'notifyAction',
  SEND_EVENT = 'sendEvent',
  ERROR_MESSAGE = 'errorMessage',
  RELOAD_GAME = 'reloadGame',
  GAME_IN_PROGRESS_RELOAD = 'gameInProgressReload',
}

export enum EvolutionMessages {
  GAME_LOAD_COMPLETED = 'EVO:APPLICATION_READY',
  GAME_LIFECYCLE = 'EVO:GAME_LIFECYCLE',
  EVENT_SUBSCRIBE = 'EVO:EVENT_SUBSCRIBE',
  REFRESH_BALANCE = 'EVO:REFRESH_BALANCE',
  STOP_AUTOPLAY = 'EVO:STOP_AUTOPLAY',
  CONTROL_VOLUME = 'EVO:CONTROL_VOLUME',
  VOLUME_STATE_CHANGE = 'EVO:VOLUME_STATE_CHANGE',
  SHOW_POPUP = 'EVO:SHOW_POPUP',
  POPUP_CLOSED = 'EVO:POPUP_CLOSED',
  APPLICATION_LOAD_STARTED = 'EVO:APPLICATION_LOAD_STARTED',
}

export enum EvolutionPopupTypes {
  LOW_BALANCE = 'lowBalance',
}

export enum EveriMessages {
  GAME_LOAD_COMPLETED = 'GAME_LOADED',
  INSUFFICIENT_FUND = 'INSUFFICIENT_FUND',
  WAGER_REQUESTED = 'WAGER_REQUESTED',
  RESULT = 'RESULT',
  SOUND_CHANGED = 'PROPERTY_UPDATE',
}

export enum AristocratEvents {
  APPLICATION_READY = 'gameReady',
  SPIN_START = 'gameStarted',
  SPIN_END = 'gameCompleted',
  SOUND_ON = 'soundOn',
  SOUND_OFF = 'soundOff',
  SHOW_DEPOSIT = 'showDeposit',
  RELOAD_BALANCE = 'setBalance',
  RESET_GAME = 'loadGame',
  AUTO_SPIN_STOP = 'playInterrupted',
  ERROR = 'error',
}

export enum ProviderLoggerMessages {
  NOT_IMPLEMENTED = 'No handler implemented for received event!',
  ERROR_NOT_HANDLED = 'No error handler implemented for the received event!',
  FAILED_HANDLER_FETCH = 'Failed to get handler for provider: %{provider}',
  UNKNOWN_EVENT = 'Event received with unexpected structure!',
  UNKNOWN_MAPPING = 'Event received from provider respects structure but has no mapping!',
  GAME_SWITCH = 'Game switch event received from provider!',
  BROKEN_FLOW = 'Unfinished game already in progress event received from provider!',
}

export enum ProviderLoggerActionNames {
  UNKNOWN_EVENT = 'UNKNOWN_EVENT',
  UNKNOWN_MAPPING = 'UNKNOWN_MAPPING',
  GAME_SWITCH = '[GAME_SWITCH]',
  GAME_SWITCH_BROKEN_FLOW = '[GAME_SWITCH][BROKEN_FLOW]',
}

export type EventHandlerMap = {
  [key: string]: (payload) => void;
};
